import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import StateContext from '../StateContext';
import DispatchContext from '../DispatchContext';
import { useContext } from 'react';

function SplashScreen() {
  const [show, setShow] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const appState = useContext(StateContext);
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Afișăm splash screen doar pe ruta principală
    if (location.pathname !== '/') {
      setShow(false);
      return;
    }

    const timer = setTimeout(() => {
      setFadeOut(true);
      
      if (!appState.isLoggedIn) {
        setTimeout(() => {
          setShow(false);
          navigate('/login');
        }, 500);
      } else {
        setTimeout(() => {
          setShow(false);
        }, 500);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [appState.isLoggedIn, navigate, location.pathname]);

  if (!show) return null;

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <img src="/assets/img/logo-aleph-rosu.png" alt="Aleph" />
    </div>
  );
}

export default SplashScreen; 